export const MALAYSIAN_STATES = [
  'Johor',
  'Kedah',
  'Kelantan',
  'Melaka',
  'Negeri Sembilan',
  'Pahang',
  'Perak',
  'Perlis',
  'Penang',
  'Sabah',
  'Sarawak',
  'Selangor',
  'Terengganu',
  'Kuala Lumpur',
  'Labuan',
  'Putrajaya',
] as const

export const MALAYSIAN_STATE_OPTIONS = MALAYSIAN_STATES.map((s) => ({
  value: s,
  label: s,
}))

/**
 * Malaysian banks for payout account linking.
 * Maybank is pinned to the top of the list to align with brand context;
 * remaining banks are alphabetical.
 */
export const MALAYSIAN_BANK_OPTIONS = [
  { value: 'Maybank', label: 'Maybank' },
  { value: 'Affin Bank', label: 'Affin Bank' },
  { value: 'Affin Islamic Bank', label: 'Affin Islamic Bank' },
  { value: 'Agrobank', label: 'Agrobank' },
  {
    value: 'Al Rajhi Banking & Investment Corporation',
    label: 'Al Rajhi Banking & Investment Corporation',
  },
  { value: 'Alliance Bank', label: 'Alliance Bank' },
  { value: 'AmBank', label: 'AmBank' },
  { value: 'AmBank Islamic', label: 'AmBank Islamic' },
  { value: 'BNP Paribas', label: 'BNP Paribas' },
  { value: 'Bangkok Bank', label: 'Bangkok Bank' },
  { value: 'Bank Islam', label: 'Bank Islam' },
  {
    value: 'Bank Kerjasama Rakyat Malaysia',
    label: 'Bank Kerjasama Rakyat Malaysia',
  },
  { value: 'Bank Muamalat', label: 'Bank Muamalat' },
  { value: 'Bank Simpanan Nasional', label: 'Bank Simpanan Nasional' },
  { value: 'Bank of America', label: 'Bank of America' },
  { value: 'Bank of China', label: 'Bank of China' },
  {
    value: 'Bank of Tokyo-Mitsubishi UFJ',
    label: 'Bank of Tokyo-Mitsubishi UFJ',
  },
  { value: 'CIMB Bank', label: 'CIMB Bank' },
  { value: 'CIMB Islamic Bank', label: 'CIMB Islamic Bank' },
  { value: 'China Construction Bank', label: 'China Construction Bank' },
  { value: 'Citibank', label: 'Citibank' },
  { value: 'Deutsche Bank', label: 'Deutsche Bank' },
  { value: 'HSBC Amanah', label: 'HSBC Amanah' },
  { value: 'HSBC Bank', label: 'HSBC Bank' },
  { value: 'Hong Leong Bank', label: 'Hong Leong Bank' },
  { value: 'Hong Leong Islamic Bank', label: 'Hong Leong Islamic Bank' },
  {
    value: 'Industrial & Commercial Bank of China (ICBC)',
    label: 'Industrial & Commercial Bank of China (ICBC)',
  },
  { value: 'JP Morgan Chase', label: 'JP Morgan Chase' },
  { value: 'Kuwait Finance House', label: 'Kuwait Finance House' },
  { value: 'MBSB Bank', label: 'MBSB Bank' },
  { value: 'Mizuho Bank', label: 'Mizuho Bank' },
  { value: 'OCBC Al-Amin Bank', label: 'OCBC Al-Amin Bank' },
  { value: 'OCBC Bank', label: 'OCBC Bank' },
  { value: 'Public Bank', label: 'Public Bank' },
  { value: 'RHB Bank', label: 'RHB Bank' },
  { value: 'Standard Chartered Bank', label: 'Standard Chartered Bank' },
  {
    value: 'Sumitomo Mitsui Banking Corporation',
    label: 'Sumitomo Mitsui Banking Corporation',
  },
  { value: 'United Overseas Bank', label: 'United Overseas Bank' },
]
